import React from 'react';
import styles from '../../../styles/components/drag-and-drop/actions/RemoveAction.module.css';
import { DragItemId } from '../DragCard';
import removeIcon from '../../../assets/minus_circle_blue.svg';

export interface ActionItem<T extends DragItemId> {
  item: T;
}

export interface RemoveActionProps<T extends DragItemId> {
  onRemove: (item: T) => void;
}

const RemoveAction = <T extends DragItemId>({
  item,
  onRemove,
}: RemoveActionProps<T> & ActionItem<T>) => {
  return (
    <div className={styles.container}>
      <div className={styles.icon} onClick={() => onRemove(item)}>
        <img src={removeIcon} alt="remove" />
      </div>
    </div>
  );
};

export default RemoveAction;
